import getField from '@form/formGenerator'

export const missionContactSaveUrl = `${import.meta.env.VITE_API_URL}/api/mission-contacts`

export const missionContactFormObject = {
  id: null,
  email: null,
  fullName: null,
  cellPhone: null,
  jobTitle: null,
  missionId: null
}

export const missionContactFormFields = (missionContactFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'jobTitle',
      label: t('labels.job_title'),
      value: missionContactFormObject.jobTitle,
      key: 'missionContact-jobTitle',
      cssClass: 'column is-6'
    }, {
      type: 'text',
      name: 'fullName',
      label: t('labels.full_name'),
      value: missionContactFormObject.fullName,
      key: 'missionContact-fullName',
      cssClass: 'column is-6'
    },
    {
      type: 'email',
      name: 'email',
      label: t('labels.email'),
      value: missionContactFormObject.email,
      key: 'missionContact-email',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'cellPhone',
      label: t('labels.cell_phone'),
      value: missionContactFormObject.cellPhone,
      key: 'missionContact-cellPhone',
      cssClass: 'column is-6'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'missionContact-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(missionContactFormObject.id),
      key: 'missionContact-id'
    },
    {
      type: 'hidden',
      name: 'missionId',
      value: parseInt(missionContactFormObject.missionId),
      key: 'missionContact-missionId'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}